import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AttributeList = () => {
  const [AttributeUser, setAttributeUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_test/attribute_list"
      );
      setAttributeUser(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_test/delete_attribute",
        { attr_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        setAttributeUser((prevUser) =>
          prevUser.filter((user) => user.attr_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Attribute-list");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete Attribute.");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Attribute List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="javascript: void(0);">Attribute</Link>
                </li>
                <li className="breadcrumb-item active">Attribute List</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <div>
                  <h4 className="card-title">All Attribute List</h4>
                </div>
                <div className="d-flex gap-2 justify-content-between align-items-center">
                  <Link to="/attribute-add" className="btn btn-sm btn-primary">
                    Add Attribute
                  </Link>
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-sm btn-outline-light rounded"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      This Month
                    </Link>
                    <div className="dropdown-menu dropdown-menu-end">
                      {/* item*/}
                      <Link to="#!" className="dropdown-item">
                        Download
                      </Link>
                      {/* item*/}
                      <Link to="#!" className="dropdown-item">
                        Export
                      </Link>
                      {/* item*/}
                      <Link to="#!" className="dropdown-item">
                        Import
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th style={{ width: 20 }}>
                          <div className="form-check fs-16 ms-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customCheck1"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customCheck1"
                            />
                          </div>
                        </th>
                        <th>ID</th>
                        <th>Attribute Name</th>
                        <th>Value</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {AttributeUser.map((user, index) => (
                        <tr>
                          <td>
                            <div className="form-check fs-16 ms-1">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customCheck2"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="customCheck2"
                              >
                                &nbsp;
                              </label>
                            </div>
                          </td>
                          <td>{index + 1}</td>
                          <td>{user.attr_name}</td>
                          <td>{user.attr_value}</td>
                          <td>
                            {" "}
                             <span className={`badge ${user.status === 'active' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                              {user.status}
                            </span>
                          </td>

                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/attribute-edit/${user.attr_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i class="fa-solid fa-pencil align-middle fs-18"></i>
                              </Link>
                              <span
                                onClick={(e) => deleteUser(user.attr_id)}
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i class="fa-solid fa-trash align-middle fs-18"></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* end table-responsive */}
              </div>
              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <Link tosName="page-link" href="javascript:void(0);">
                        Previous
                      </Link>
                    </li>
                    <li className="page-item active">
                      <Link tosName="page-link" href="javascript:void(0);">
                        1
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link tosName="page-link" href="javascript:void(0);">
                        2
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link tosName="page-link" href="javascript:void(0);">
                        3
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link tosName="page-link" href="javascript:void(0);">
                        Next
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default AttributeList;
